
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { useShopContext } from 'src/pages/main/shop/contexts/ShopContext'

import ShopBlock from 'src/pages/main/shop/components/ShopBlock'
import ShopExchangeHeart from 'src/pages/main/shop/components/ShopHeartTab/ShopExchangeHeart'

const ShopHeartTab = ({ data }) => {
  const { specialItemId } = useShopContext()

  const isValidConfig = (config) => {
    const hasValidDiamonds = Number.isInteger(config.number_of_red_diamonds)
    const isDreamLamp = config.name === '夢のランプ'
    const hasValidHearts = Number.isInteger(config.number_of_hearts_exchanged) ||
      (isDreamLamp && config.number_of_hearts_exchanged === null)

    return hasValidDiamonds && hasValidHearts
  }

  const isHasDreamItem = (item) => item.name === '夢のランプ' && data.has_dream_item

  const filteredItems = useMemo(() => {
    if (!data?.items) return []

    return data.items
      .filter(item => isValidConfig(item) && !isHasDreamItem(item))
  }, [data, specialItemId])

  return (
    <div className="flex flex-col items-center justify-center w-full gap-4">
      {filteredItems.map((heartExchangeConfig, index) => (
        <ShopBlock key={index}>
          <ShopExchangeHeart heartExchangeConfig={heartExchangeConfig} />
        </ShopBlock>
      ))}
    </div>
  )
}

ShopHeartTab.propTypes = {
  data: PropTypes.object
}

export default ShopHeartTab
